import { accessor } from '../store';
import { messages } from 'src/i18n/i18n';
import { RouteEntityDetail } from '@redviking/argonaut-core-ui/src/components/EntityDetail';
import { Route } from 'vue-router';
import { RouterViewSlider } from '@redviking/argonaut-core-ui/src/components/RouterViewSlider';
import { entityDetailRoute } from '../components/EntityDetail';
import { createWorkInstruction, getWorkInstruction, saveWorkInstruction } from './work-instruction.entity';
import { validateAcls } from '@redviking/argonaut-core-ui/src/auth';
import type { RouteConfig } from 'vue-router';

export function validateWorkInstructionSelectAcl (): boolean {
    return validateAcls([ 'work_instruction_select' ]);
}

export function validateWorkInstructionManageAcl (): boolean {
    return validateAcls([ 'work_instruction_update' ]);
}

const workInstructionsRoutes: RouteConfig[] = [
    {
        path: '/work-instructions',
        name: 'workInstructions',
        component: RouterViewSlider,
        redirect: { name: 'workInstructionList' },
        meta: {
            navigationGuard: () => validateWorkInstructionSelectAcl(),
            transition: 'horizontal',
            navbarIcon: 'mdi-text-box-multiple-outline',
            navbarTitle: messages.workInstructions.titles.nav,
            featureFlags: [ 'unstableWorkInstructions' ],
        },
        children: [
            {
                path: '',
                name: 'workInstructionList',
                component: () => import(/* webpackChunkName: "work-instructions" */ './WorkInstructionsList.vue'),
                meta: {
                    pageBannerTitle: messages.workInstructions.titles.pageBannerTitle,
                    pageBannerSubtitle: messages.workInstructions.titles.pageBannerSubtitle,
                },
            },
            entityDetailRoute<'workInstruction'>({
                path: ':workInstructionId/version/:versionId',
                component: RouteEntityDetail,
                name: 'workInstructionDetail',
                redirect: to => ({ name: 'workInstructionSettings', params: to.params }),
                meta: {
                    // the fab banner btn is conditionally rendered on the `WorkInstructionSettings` component
                    canEdit: false,
                    useEntityDetailTabs: false,
                    entityType: 'workInstruction',
                    getEntity: getWorkInstruction,
                    saveEntity: saveWorkInstruction,
                    createEntity: createWorkInstruction,
                    pageBannerSubtitle: 'Define a sequence of steps to complete a task',
                    returnRoute: (route: Route) => ({ name: 'workInstructionList', query: route.query }),
                    pageBannerTitle: (to: Route) => {
                        const entityData = accessor.entityAsType('workInstruction');
                        if (!entityData) {
                            return 'Unknown';
                        }
                        const name = entityData.name;
                        if (!name && to.query.mode === 'create') {
                            return 'New Work Instruction';
                        }
                        return `${name}`;
                    },
                },
                children: [
                    {
                        path: 'settings',
                        name: 'workInstructionSettings',
                        component: () => import(/* webpackChunkName: "work-instructions" */ './WorkInstructionSettings.vue'),
                    },
                ],
            }),
        ],
    },
];

export default workInstructionsRoutes;
